/*
 * SPDX-FileCopyrightText: 2022 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { PostApiRequestBuilder } from '@api/common/api-request-builder/post-api-request-builder';

const BASE_API_URL = 'cms/version';

export const getVersionContent = async (
  versionId: string,
  entitySlug: string,
  entityType: string = 'article',
  entityAttribute: string = 'content'
): Promise<any> => {
  const response = await new PostApiRequestBuilder(
    '',
    '',
    `${BASE_API_URL}/${entityType}/${entitySlug}/${entityAttribute}`
  )
    .withJsonBody({
      version_id: versionId
    })
    .sendRequest();
  return response.asParsedJsonObject();
};
